import { render } from "./GroupHeader.vue?vue&type=template&id=7f68d8c1&scoped=true"
import script from "./GroupHeader.vue?vue&type=script&lang=js"
export * from "./GroupHeader.vue?vue&type=script&lang=js"

import "./GroupHeader.vue?vue&type=style&index=0&id=7f68d8c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f68d8c1"]])

export default __exports__